import { render, staticRenderFns } from "./ExchangeDetailDialog.vue?vue&type=template&id=189ceb5c&scoped=true&"
import script from "./ExchangeDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ExchangeDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeDetailDialog.vue?vue&type=style&index=0&id=189ceb5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ceb5c",
  null
  
)

export default component.exports